import { z } from 'zod';
import { envelope, IdString, Platform, TaxCode } from './common.js';

/** Thanh ngữ cảnh trên web: Công ty (tenant) → Pháp nhân → Shop → Kỳ. */
export const ShopRef = z.object({
  id: IdString,
  platform: Platform,
  shopId: z.string(),
  shopName: z.string(),
  validFrom: z.string(),
  validTo: z.string().nullable(),
});
export type ShopRef = z.infer<typeof ShopRef>;

export const LegalEntityRef = z.object({
  id: IdString,
  taxCode: TaxCode,
  name: z.string(),
  shortName: z.string().nullable(),
  shops: z.array(ShopRef),
});
export type LegalEntityRef = z.infer<typeof LegalEntityRef>;

export const TenantRef = z.object({
  id: IdString,
  code: z.string(),
  name: z.string(),
  /** Công ty demo: dữ liệu giả lập, không kết nối shop thật. */
  isDemo: z.boolean(),
  /** Kỳ tháng gần nhất có dữ liệu đơn hàng (web chọn mặc định), null nếu chưa có. */
  latestPeriod: z.string().nullable(),
  legalEntities: z.array(LegalEntityRef),
});
export type TenantRef = z.infer<typeof TenantRef>;

export const ContextResponse = envelope(z.object({ tenants: z.array(TenantRef) }));
export type ContextResponse = z.infer<typeof ContextResponse>;

/** Tham số ngữ cảnh lưu trên URL của web. */
export const ContextParams = z.object({
  company: IdString.optional(),
  entity: IdString.optional(),
  shop: IdString.optional(),
  period: z.string().optional(),
});
export type ContextParams = z.infer<typeof ContextParams>;
